import React from 'react';

export const AllocationHeader = () => {
    return (
        <div className="w-full py-6 text-center">
            <div className="staking-text-and-stats-flex flex items-center justify-between w-full mt-6 px-4 pb-4">
                <div className="staking-page-main-text-container text-left">
                    <p className="mb-2 font-semibold md:text-6xl text-5xl">Allocation Market</p>
                    <p className="text-2xl mb-2 font-light">
                        Connect your wallet &amp; get allocation for METAMASK shares.
                    </p>
                </div>
            </div>
        </div>
    )
};
